import { render, staticRenderFns } from "./techVideoDetail.vue?vue&type=template&id=195af408&scoped=true&lang=pug"
import script from "./techVideoDetail.vue?vue&type=script&lang=js"
export * from "./techVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./techVideoDetail.vue?vue&type=style&index=0&id=195af408&prod&lang=scss&scoped=true"
import style1 from "./techVideoDetail.vue?vue&type=style&index=1&id=195af408&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195af408",
  null
  
)

export default component.exports